
// 偏移矩形
export const offsetRect = (rect: any, x: number, y: number) => {
    return [rect[0] + x, rect[1] + y, rect[2] + x, rect[3] + y];
};
// 格式化时间显示
export const formatDateByLocale = (locale, d) => {
    return new Date(d).toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    })
}
